
export const ActionTypes = {
    GET_PRODUCTS_LOADING : "GET_PRODUCTS_LOADING",
    GET_PRODUCTS_SUCCESS : "GET_PRODUCTS_SUCCESS",
    GET_PRODUCTS_ERROR : "GET_PRODUCTS_ERROR",
    
    GET_SINGLE_PRODUCT_LOADING : "GET_SINGLE_PRODUCT_LOADING",
    GET_SINGLE_PRODUCT_SUCCESS : "GET_SINGLE_PRODUCT_SUCCESS",
    GET_SINGLE_PRODUCT_ERROR : "GET_SINGLE_PRODUCT_ERROR",

    LOAD_PRODUCTS: "LOAD_PRODUCTS",
    UPDATE_SORT: "UPDATE_SORT",
    SORT_PRODUCTS: "SORT_PRODUCTS",

    UPDATE_FILTERS: "UPDATE_FILTERS",
    FILTER_PRODUCTS: "FILTER_PRODUCTS",
    CLEAR_FILTERS: "CLEAR_FILTERS",

    UPDATE_CHECKBOXES: "UPDATE_CHECKBOXES",
    
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_ITEM: "REMOVE_ITEM",
    TOGGLE_AMOUNT: "TOGGLE_AMOUNT",
    CLEAR_CART: "CLEAR_CART",
    GET_TOTALS: "GET_TOTALS"
}




